export const ENV = process.env.NEXT_PUBLIC_ENV;

export const IS_PROD = ENV === 'prod';
export const IS_TEST = ENV === 'test';
export const IS_DEV = ENV === 'dev';
